export enum PlaidAccountStatus {
  NO_TXN_DATA = 'NO_TXN_DATA', // Initial transaction pull has not occurred.
  INITIAL_PULL_COMPLETE = 'INITIAL_PULL_COMPLETE', // Initial transactional data has been pulled.
  READY = 'READY', // Initial and historical pulls have been completed.
  ERROR = 'ERROR', // There is an error with the account, likely to do with authentication
  AUTH_ERROR = 'AUTH_ERROR', // Authentication error
  PENDING_READY = 'PENDING_READY', // internal status after user fixes AUTH_ERROR
}
